<template>
    <div  class="row">
        <div class="col s-12">
            <!-- Modal Structure -->
            <div :id="`modal${index}`" class="modal modal-fixed-footer">
                <div class="modal-content">
                    <h4><slot name='header'></slot></h4>
                    <p><slot name='description'></slot></p>
                </div>
                <div class="modal-footer">
                    <slot name='footer'></slot>
                    <a href="#!" class="modal-close waves-effect waves-green btn-flat">Fechar</a>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
    .modal { width: 100% !important ; height: 100% !important ; }  /* increase the height and width as you desire */

</style>
<script>
    export default {
        name:'BaseModal',
        props:{
            index: Number
        },
        data(){
            return {
                item:{

                }
            };
        },
        methods:{
            addItem(){
            
            },
            setDestroy(){
                this.$emit('is-destroy',true);
            }
        },
        mounted(){
            $(document).ready(function(){
                $('.modal').modal();
            });
        }
    }
</script>